import { SquareMinus, SquarePlus } from 'lucide-react';
import React from 'react';

const propTypes = {};

const DataGridExpandCell = ({ row, getValue }) => {
  //! State

  //! Function

  //! Render
  return (
    <div className='component:DataGridExpandCell tw-w-[32px] tw-flex tw-items-center tw-justify-center'>
      {row.getCanExpand() ? (
        <button onClick={row.getToggleExpandedHandler()} style={{ cursor: 'pointer' }}>
          {row.getIsExpanded() ? <SquareMinus size={16} /> : <SquarePlus size={16} />}
        </button>
      ) : (
        ''
      )}
      {getValue()}
    </div>
  );
};

DataGridExpandCell.propTypes = propTypes;
export default DataGridExpandCell;
